import {
  extractPathComponents,
  makePathFromComponents,
} from '../router/helpers'

function createInstance() {
  const router = useRouter()
  const { routePath } = useRoutePath()

  const currentPathComponents = computed(() => {
    return extractPathComponents(routePath.value)
  })

  const currentPath = toRef(() =>
    currentPathComponents.value?.path,
  )

  const r = ({ path, isV2Path = true, includeWidgetPrefix = true, applyCurrentProviderPrefix = true }) => {
    const { widgetPrefix } = currentPathComponents.value
    const { currentProviderPrefix } = useSessionData()

    return makePathFromComponents(
      {
        path,
        widgetPrefix,
        providerPrefix: currentProviderPrefix,
      },
      {
        includeBaseRoute: isV2Path,
        includeWidgetPrefix,
        includeProviderPrefix: applyCurrentProviderPrefix,
      },
    )
  }

  const redirectTo = (route, useRouter = true) => {
    if (useRouter)
      router.push(route)
    else window.location.href = route
    return false
  }

  return {
    currentPathComponents,
    currentPath,
    r,
    redirectTo,
  }
}

export const useRoutes = useSingleton(createInstance)
